import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../../types";
import {
  CreateWebinarData,
  GetSingleWebinarData,
  GetWebinarData,
  GetWebinarDataParams,
} from "../../../../types/eventManage/webinars";
import { handleApiError } from "../../../../utils/errorHandler";

// create
export const createWebinarAsync = createAsyncThunk<
  null,
  PostRequest<CreateWebinarData, CommonOthers>
>(
  "admin/createWebinar",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createWebinar, data);

      reRender(true);
      toast("success", "Webinar create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Webinar create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllWebinarAsync = createAsyncThunk<
  GetCommonData<GetWebinarData>,
  Params<GetWebinarDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllWebinar", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetWebinarDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllWebinars, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get webinar fail");
    return rejectWithValue(error);
  }
});

// update
export const updateWebinarAsync = createAsyncThunk<
  null,
  PostRequest<CreateWebinarData, GetSingleDataParams>
>(
  "admin/updateWebinar",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateWebinar}/${id}`, data);

      reRender && reRender(true);
      toast("success", "Webinar update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Webinar update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singWebinarDataAsync = createAsyncThunk<
  GetSingleWebinarData,
  Params<GetSingleDataParams>
>("admin/singWebinarData", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(`${BASE_API.getSingleWebinar}/${params?.id}`, {
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });
    return data?.data?.data;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single webinar data get fail");
    return rejectWithValue(error);
  }
});
